import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { ButtonReturn } from '../../../components/common/ButtonReturn';
import { voicesTypeControl } from '../../../types/audioType';
import { Sospechoso1, Sospechoso2 } from '../../../assets/tema8';
import { QuestionCardV3 } from '../../../components/common/QuestionCardV3';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	win: 3,
	fail: 4
};


const gameQuestion = [
	{
		id: 1,
		question: "Un cliente no presenta una identificación oficial o se encuentra totalmente borrosa o con tachaduras en sus datos o se niegue a presentar su información completa. ¿Qué debe hacerse?",
		img: Sospechoso1,
		options: [
			{
				id: 1,
				text: "Permitirle hacer la operación y solicitar que dicte los datos que no pudieron ser visualizados en la identificación.",
			},
			{
				id: 2,
				text: "Permitirle hacer la operación y colocar cualquier información en los campos faltantes.",
			},
			{
				id: 3,
				text: "Negarle hacer la operación e indicarle que es necesario presentar una Identificación Oficial, además de proporcionar sus datos reales.",
				isCorrect: true
			},
		]
	},
	{
		id: 2,
		question: "Un cliente recurrente, presenta números de teléfono distintos cada vez que realiza una operación o cada vez le envía dinero a distintas personas ¿Qué debe hacerse?",
		img: Sospechoso2,
		options: [
			{
				id: 1,
				text: "Indicarle que esta mal enviarle dinero a varias personas.",
			},
			{
				id: 2,
				text: "Realizar operación normalmente, pero dar aviso de la situación por medio de la herramienta ATL.",
				isCorrect: true,
			},
			{
				id: 3,
				text: "Indicarle que ponga el mismo número de teléfono en todas las operaciones.",
			},
		]
	},
]


let pointsWin = 0

export const Theme8SubtopicTwoActivityFive = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema8.activities.subtema2], 5);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 8 sub 2 act 5");
			ObserverEmitter.emit(EVENTS.tema8.topic2.initScene, 5);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema2.actividad5.sub2a5a01)
	})

	const goFinish = () => {
		dispatch(
			completeOneTask({
				idActivity: 5,
				pointsWin: pointsWin,
				subtema: tasksId.tema8.activities.subtema2
			})
		);
		navigator("/home8/tema8/subtema2/activityresult");
	}

	const [selectQuestionGame, setSelectQuestionGame] = useState({
		question: "",
		img: "",
		options: [
			{
				id: 1,
				text: ""
			},
			{
				id: 2,
				text: ""
			},
			{
				id: 3,
				text: ""
			},
		]
	})
	const [numberQuestion, setNumberQuestion] = useState(0)
	const [saveResponse, setSaveResponse] = useState(0)

	const actionGameQuestion = (statusCorrect = 0) => {

		if (statusCorrect === 1) {
			pointsWin += 15
		}

		const updatedResponse = statusCorrect === 1 ? saveResponse + 1 : saveResponse;
		setSaveResponse(updatedResponse);

		if (numberQuestion >= gameQuestion.length - 1) {
			if (updatedResponse === 2) {
				setUiToShow(steps.win);
			} else {
				setUiToShow(steps.fail);
			}
			return;
		}

		if (numberQuestion < gameQuestion.length - 1) {
			setNumberQuestion(numberQuestion + 1);
		}
	};

	const setDataQuestion = () => {
		const selectData = gameQuestion[numberQuestion]
		setSelectQuestionGame(selectData)
	}

	useEffect(() => {
		setDataQuestion()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [numberQuestion])

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema8.topic2.initScene, 5);
						pointsWin = 0
						setNumberQuestion(0)
						setSaveResponse(0)
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name='Ejercicio: Preguntas.' />
					<DialogBarNew
						dialog={`¡Excelente trabajo! a continuación, lee las preguntas y contesta lo que se te pide.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2. Situaciones de riesgo"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(-1);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === -1 && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<BarStatusActivies
						activities={tasksList}
					/>
					<QuestionCardV3 data={selectQuestionGame} actionGameQuestion={actionGameQuestion} />
				</>
			)}

			{
				uiToShow === steps.win && (
					<>
						<ValidationResultModal
							title="¡Bien hecho!"
							numberPoints={pointsWin}
							dialogModal="Has contestado de manera correcta las preguntas. ¡Excelente trabajo! "
							buttonTxt="Continuar"
							isCorrect={true}
							action={() => {
								goFinish()
							}}
						/>
					</>
				)
			}


			{
				uiToShow === steps.fail && (
					<>
						<ValidationResultModal
							title="Respuesta incorrecta."
							dialogModal="Parece que tuviste dificultades en contestar las preguntas, recuerda poner atención en todo momento."
							buttonTxt="Continuar"
							isCorrect={false}
							action={() => {
								goFinish()
							}}
						/>
					</>
				)
			}
		</>
	)
}
